module.exports = __webpack_public_path__ + "static/media/new-york-31.d00b919e.jpg";